import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';

const ViewPDF = () => {
  const location = useLocation();
  const { id } = useParams();
  const [pdfUrl, setPdfUrl] = useState(location.state?.pdfUrl || null);
  const [loading, setLoading] = useState(!pdfUrl);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pdfUrl && id) {
      axios.get(`https://backend.aktcorp.com/compliances/${id}`)
        .then(res => {
          setPdfUrl(res.data.pdfUrl);
          setLoading(false);
        })
        .catch(err => {
          setError('Failed to fetch PDF');
          console.log(err);
          setLoading(false);
        });
    }
  }, [id, pdfUrl]);

  if (loading) return <p>Loading PDF...</p>;
  if (error) return <p className="text-red-500">{error}</p>;
  if (!pdfUrl) return <p className="text-red-500">PDF not found.</p>;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 rounded-lg">
      <iframe
        src={pdfUrl}
        className="w-full h-[90vh]"
        title="PDF Viewer"
      />
    </div>
  );
};

export default ViewPDF;
